$(document).on('ready', function () {
    $(document).on('click', '.js-profile-edit-btn, .js-profile-edit-cancel', function (e) {
        e.preventDefault();
        $('.js-profile-info').slideToggle('fast');
        $('.js-profile-form').slideToggle('fast');
    });

    $(document).on('click', 'a.send-email-confirmation', function () {
        var $form = $(this).closest('form');
        $.post($(this).attr('href'), {
            login: $form.find("input[name='login']").val()
        }, function (response) {
            $form.find('.error-msg').empty();//.after($('<p><em></em>').html(response));
            $form.find('.block-confirmation-email').html(response);
        });
        return false;
    });

});